import { AttributeGroup } from 'state/attributeGroup'

MK.events.on('attribute:group:toggle', (event = {}) => {
  console.log('======================= TOGGLE ===========================')
  const group = event.target
  group.is[event.property] = (typeof event.value === 'boolean' ? event.value : !group.is[event.property])
  console.log(`DEBUG (attribute:group:toggle): Toggling ${event.property}: ${group.is[event.property]} for ${group.name}`, group.is)

  if (event.property === 'highlighted' && group.is.highlighted) {
    console.log('===================== Highlight Toggle =============================')
    AttributeGroup.groups.filter(group => event.target.id !== group.id).forEach(group => {
      group.is.highlighted = false
      console.log(group)
      // group.updateClasses()
    })
  }

  return true
})